import { useState } from 'react'
import { useSelector } from 'react-redux'

import QuickSelectComponent from '../../../../components/stories/organisms/top-navigation/components/quick-select/index.jsx'
import { useGetMyProjectsQuery } from '../../../../react-query/project/query/use-get-my-projects-query.jsx'

import CustomFolderItem from './custom-folder-item.jsx'
import { useHistory } from 'react-router-dom'
import { makeSelectProjectDetails } from '../../../ProjectSettings/selectors.js'
import { typeFileQuickSelectOptions } from '../../../../components/stories/organisms/top-navigation/constants.js'
import { useIntl } from 'react-intl'
import { useDebounce } from '../../../../utils/customHooks.js'

const ProjectSelect = () => {
  const { push } = useHistory()
  const [search, setSearch] = useState('')
  const debouncedSearch = useDebounce(search, 300)

  const { formatMessage } = useIntl()
  const { data, isLoading } = useGetMyProjectsQuery(debouncedSearch)

  const project = useSelector(makeSelectProjectDetails())

  const handleClick = (item) => {
    push(`/project/${item.id}`)
  }

  return (
    <QuickSelectComponent.Root>
      <QuickSelectComponent.Label
        label={project?.name ?? formatMessage({ id: 'project_Root' })}
        disabled={false}
      />
      <QuickSelectComponent.List
        isLoading={isLoading}
        setSearchValue={setSearch}
        searchValue={search}
      >
        <QuickSelectComponent.RecursiveList
          data={data}
          itemComponent={
            <QuickSelectComponent.Item
              handleCallback={handleClick}
              selectedItem={project?.id ?? null}
              itemType={typeFileQuickSelectOptions.PROJECT}
            />
          }
          folderComponent={<CustomFolderItem />}
        />
      </QuickSelectComponent.List>
    </QuickSelectComponent.Root>
  )
}

export default ProjectSelect
